/**
 * The Eloquor wordmark — two opposing arcs + Ember dot + "Eloquor" in
 * Source Serif 4 Black. Inline SVG so `currentColor` follows the
 * surrounding text color (used on both light and dark surfaces).
 */

import { Link } from 'react-router-dom';

export interface WordmarkProps {
  /** Path to navigate on click; null disables the link. */
  to?: string | null;
  /** 'paper' = on dark Ink surfaces; 'ink' = on light Paper surfaces. */
  tone?: 'paper' | 'ink';
  size?: number;
}

export function Wordmark({ to = '/', tone = 'ink', size = 20 }: WordmarkProps) {
  const color = tone === 'paper' ? 'var(--paper)' : 'var(--ink)';
  const content = (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 11,
        fontFamily: '"Source Serif 4", Georgia, serif',
        fontWeight: 900,
        fontSize: size,
        letterSpacing: '-0.03em',
        color,
        lineHeight: 1,
        textDecoration: 'none',
      }}
    >
      <svg
        width={size + 2}
        height={size + 2}
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M2 16 C 9 8, 9 8, 16 16 C 23 24, 23 24, 30 16"
          stroke="currentColor"
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 16 C 9 24, 9 24, 16 16 C 23 8, 23 8, 30 16"
          stroke="currentColor"
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="16" cy="16" r="2.6" fill="var(--ember)" />
      </svg>
      Eloquor
    </span>
  );
  if (to === null) return content;
  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      {content}
    </Link>
  );
}
